import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';
import { useGetLocationSettlement } from 'entities/creditForm';

export const useWorkLocationRouteLoader = () => {
  const { watch, setValue } = useFormContext<TWorkplaceFormFields>();
  const [loadLocationSettlement, { data }] = useGetLocationSettlement();
  const workAddress = watch('workAddress');

  const getLocationSettlement = useCallback(
    async (address: string) => {
      loadLocationSettlement(address, true);
    },
    [loadLocationSettlement],
  );

  useEffect(() => {
    if (data) {
      setValue('workLocationRoute', data.route || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (workAddress?.value && (workAddress?.data as unknown as { type: 'manual' })?.type !== 'manual') {
      getLocationSettlement(String(workAddress.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workAddress?.value]);
};
